import React, { useState, useEffect } from "react";
import Api from "../../components/api/Api";
// eslint-disable-next-line no-unused-vars
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import Notification, {
  showToast,
} from "../../../components/common/notification/Notification";
import { Link, useParams } from "react-router-dom";
import SingleDetailHeader from "../../components/singleDetail/SingleDetailHeader";
import SingleDetail from "../../components/singleDetail/SingleDetail";
import BreadCrumb from "../../components/breadcrumb/BreadCrumb";

const LocalBazaarItem = () => {
  const { Id } = useParams();

  // eslint-disable-next-line no-unused-vars
  const [isLoading, setIsLoading] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [isError, setIsError] = useState(false);

  const getApi = Api({
    url: `api/local/bazaar/categories/view/${Id}`,
  });

  const [formData, setFormData] = useState({
    name: "",
    description: "",
  });

  useEffect(() => {
    const fetchPostData = async () => {
      try {
        setIsLoading(true);
        const response = await getApi.fetchDataBySingleId(true);
        console.log(response);
        if (response?.data?.statusType === "SUCCESS") {
          const postData = response.data.localBazaarCategory;

          setFormData({
            name: postData.name,
            description: postData.description,
          });
        }
      } catch (error) {
        setIsError(true);
        console.error(error);
        showToast("Error Occurred", { type: "error" });
      } finally {
        setIsLoading(false);
      }
    };

    fetchPostData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const breadcrumbItems = [
    { label: "", link: "/admin", icon: "fa-solid fa-house" },
    { label: "Master", link: "/user" },
    { label: "Local Bazaar", link: "/local-bazaar" },
    { label: "Catalog Type Details", link: "", active: true },
  ];
  return (
    <>
      <Notification />
      <Container>
        <BreadCrumb items={breadcrumbItems} />
        <Row>
          <Col lg={12} md={12} sm={12}>
            <SingleDetailHeader
              header="Catalog Type Details"
              description="Catalog type details section"
            />

            <Row>
              <Col>
                <div className="mb-3">
                  <SingleDetail label="Name" userDetail={formData?.name} />
                </div>
                <div className="mb-3">
                  <SingleDetail label="Description" userDetail={formData?.description} />
                </div>
              </Col>
            </Row>

            <div>
              <Button className={`btn btn-primary mb-3 mt-3 ml-3`}>
                <Link
                  className="text-white"
                  to={`/local-bazaar/${Id}/edit`}
                >
                  Edit
                </Link>
              </Button>

              <Link
                style={{ marginLeft: "1rem" }}
                className="btn btn-primary mb-3 mt-3 ml-3"
                to={"/local-bazaar"}
              >
                Back
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default LocalBazaarItem;